import {
  Alert,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import CustomerBalanceApi from "../../../../../infrastructure/api/customerBalance";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import PanelBalanceCard from "../../../../components/payment-gateway/PanelBalanceCard";
import { formatRial, pick } from "../../../../components/payment-gateway/paymentGatewayUtils";
import { toJalaliFullDate } from "../../../../middleware/middleware";

const CustomerBalanceHistoryPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await CustomerBalanceApi.getTransactions(1, 50);
      if (res?.isSuccess === false) {
        setError(res?.message || "بارگذاری تاریخچه ناموفق بود.");
        setItems([]);
        return;
      }
      const data = res?.data ?? res?.Data;
      setItems(pick(data, "items", "Items") ?? []);
    } catch {
      setError("بارگذاری تاریخچه ناموفق بود.");
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} lg={8} sx={{ mx: "auto" }}>
        <Stack spacing={2}>
          <PanelBalanceCard compact showHistoryLink={false} />

          <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              تاریخچه اعتبار
            </Typography>

            {error ? <Alert severity="warning">{error}</Alert> : null}

            {!error && !loading && items.length === 0 ? (
              <Alert severity="info">تراکنش اعتباری ثبت نشده است.</Alert>
            ) : null}

            {items.length > 0 ? (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>تاریخ</TableCell>
                    <TableCell>نوع</TableCell>
                    <TableCell>مبلغ</TableCell>
                    <TableCell>مانده پس از تراکنش</TableCell>
                    <TableCell>شرح</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((row) => (
                    <TableRow key={pick(row, "id", "Id")}>
                      <TableCell>
                        {toJalaliFullDate(pick(row, "createdAt", "CreatedAt"))}
                      </TableCell>
                      <TableCell>
                        {pick(row, "reasonTitle", "ReasonTitle") ??
                          pick(row, "typeTitle", "TypeTitle")}
                      </TableCell>
                      <TableCell>
                        {formatRial(pick(row, "amount", "Amount"))}
                      </TableCell>
                      <TableCell>
                        {formatRial(pick(row, "balanceAfter", "BalanceAfter"))}
                      </TableCell>
                      <TableCell>{pick(row, "description", "Description") ?? "—"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : null}
          </Paper>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default CustomerBalanceHistoryPage;
